<template>
  <v-container fluid class="pa-0 form-page-gutter">
    <vendor-form v-if="!isUpdating"></vendor-form>
    <v-card v-if="isUpdating" elevation="0" class="grey lighten-3">
      <v-card-text
        class="vendor-detail-header d-flex align-center justify-space-between flex-wrap flex-md-nowrap flex-lg-nowrap"
      >
        <div v-if="isUpdating" class="vendor-summary">
          <div class="vendor-title">
            <span class="vendor-id blue--text">#{{ vendor.id }}</span>
            <span>{{ vendor.name }}</span>
          </div>
          <div v-if="vendor.phone" class="vendor-meta">
            {{ vendor.phone }}
          </div>
        </div>
        <div class="vendor-actions">
          <v-btn
            v-if="isUpdating"
            class="mr-2"
            color="primary"
            depressed
            rounded
            @click="vendorDialog = true"
            ><i class="fas fa-save mr-2"></i>Edit Vendor</v-btn
          ><v-menu rounded offset-y>
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                depressed
                rounded
                color="success"
                v-bind="attrs"
                v-on="on"
                :loading="isLoading"
              >
                <i class="fa-solid fa-caret-down mr-2"></i>Actions
              </v-btn>
            </template>

            <v-list>
              <v-list-item link @click="newExpense">
                <v-list-item-title>New Expense</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </v-card-text>
    </v-card>

    <vendor-dashboard :vendor="vendor" v-if="isUpdating"> </vendor-dashboard>
    <vendor-dialog
      :p-vendor="vendor"
      :isUpdating="isUpdating"
      v-model="vendorDialog"
      @handleChange="(val) => (vendor = val)"
    ></vendor-dialog>
  </v-container>
</template>
<script>
import backendService from "@/services/backend-service";
import eventBus from "@/js/event-bus";
import generalMixin from "@/js/general-mixin";
import formMixin from "@/js/form-mixin";
import VendorDashboard from "@/components/VendorDashboard.vue";
import VendorDialog from "@/components/VendorDialog.vue";
import VendorForm from "@/components/VendorForm.vue";
export default {
  name: "VendorForm",
  mixins: [generalMixin, formMixin],
  components: {
    "vendor-dashboard": VendorDashboard,
    "vendor-dialog": VendorDialog,
    "vendor-form": VendorForm,
  },
  mounted: function () {
    if (this.$route.params.id) {
      this.getUpdateForm();
    }
  },
  data() {
    return {
      isLoading: false,
      isUpdating: false,
      vendorDialog: false,
      vendor: {},
    };
  },

  computed: {},
  methods: {
    generateInvoiceCsv() {
      eventBus.$emit("generateInvoiceCsv");
    },
    getUpdateForm() {
      this.isUpdating = true;
      this.isLoading = true;
      this.getVendorById(this.$route.params.id);
    },
    getVendorById(id) {
      backendService
        .getVendorById(id)
        .then((response) => {
          this.vendor = response.data;
          this.timer(1000).then(() => {
            this.isLoading = false;
          });
        })
        .catch(() => {
          this.timer(1000).then(() => {
            this.isLoading = false;
          });
        });
    },

    newExpense() {
      this.$router.push({
        name: "NewExpense",
        params: { vendorId: this.vendor.id, isGenerating: true },
      });
    },
  },
  watch: {
    "$route.params.id": function (newVal, oldVal) {
      if (newVal != oldVal) this.getUpdateForm();
    },
  },
  destroyed: function () {
    eventBus.$off("generateInvoiceCsv");
  },
};
</script>
<style scoped>
.vendor-detail-header {
  gap: 12px;
  padding-bottom: 12px;
  padding-top: 12px;
}
.vendor-summary {
  min-width: 0;
}
.vendor-title {
  align-items: baseline;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.vendor-id {
  font-size: 18px;
  font-weight: 600;
}
.vendor-meta {
  color: rgba(0, 0, 0, 0.6);
  font-size: 14px;
  line-height: 1.4;
  margin-top: 4px;
}
.vendor-actions {
  align-items: center;
  display: flex;
  flex-shrink: 0;
  gap: 8px;
}
</style>
